import { apiGetCostsChart, apiGetIncomesChart } from "api/dashboardApi";
import { toIncomesCostsDataFormat } from "helpers/dataFormat";
import { useEffect, useState } from "react";
import BarChart from "../Chart/BarChart";
import { BoxUpper } from "../Shared/BoxUpper";
import { BoxBodyContainer, RawBox } from "../Shared/Dashboard/styled";
import { useAppDispatch, useAppSelector } from "store/store";
import { memo } from "react";
import DashboardErrorBoundary from "./DashboardErrorBoundary";
import { Skeleton, Typography, Box } from "@mui/material";
import RefreshIcon from "assets/icons/RefreshIcon";

const BarChartComponent = ({ title }: { title?: string }) => {
  const [selectOption, setSelectOption] = useState("lastYear");
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.businessReducer.business?.token);
  const incomesChart = useAppSelector(
    (state: any) => state.dashboardReducer.incomesChart
  ) as buyAndSaleDataType;
  const costsChart = useAppSelector((state: any) => state.dashboardReducer.costsChart) as buyAndSaleDataType;
  // useEffect(() => {
  //   if (token) {
  //     dispatch(apiGetIncomesChart(token));
  //     dispatch(apiGetCostsChart(token));
  //   }
  // }, [token]);

  const [isLoading, setLoading] = useState(false)
  const changeLoading = () => {
    setLoading(state => !state)
  }
  const handleChange = (filterType: string) => {
    setSelectOption(filterType);
    dispatch(apiGetIncomesChart(token, filterType, () => { }));
    dispatch(apiGetCostsChart(token, filterType, changeLoading));
  };

  const options = [
    { label: "کل سال مالی", value: "lastYear", id: 1 },
    { label: "شش ماه اخیر", value: "lastSixMonth", id: 2 },
    { label: "ماه اخیر", value: "lastMonth", id: 3 },
    { label: "هفته اخیر", value: "lastWeek", id: 4 },
  ];
  return (
    <RawBox>
      <BoxUpper onChange={handleChange} options={options} title={title} />
      <BoxBodyContainer>
        <DashboardErrorBoundary fallback={<div className="h-[320px]"></div>}>
          {
            incomesChart && costsChart ? (
              <BarChart
                selectOption={selectOption}
                data={toIncomesCostsDataFormat(incomesChart, costsChart)}
                height={320}
              />
            ) : (
              <Box
                onClick={() => {
                  handleChange('lastYear')
                }}
                sx={{
                  position: 'relative',
                  width: '100%', // Set your desired width
                  height: 320, // Set your desired height
                  display: 'flex',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  alignItems: 'center',
                  // border: '1px solid #ccc', // Optional: for visual reference
                }}
              >
                <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
                <Typography
                  variant="h6"
                  sx={{
                    position: 'absolute',
                    color: '#747575', // Change color based on your skeleton background
                  }}
                >
                  نمایش نمودار
                </Typography>
                <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>

              </Box>
            )
          }

        </DashboardErrorBoundary>
      </BoxBodyContainer>
    </RawBox>
  );
};

export default memo(BarChartComponent);
